import React, { useState } from "react";
import {
	GoogleAuthProvider,
	signInWithEmailAndPassword,
	signInWithPopup
} from "firebase/auth";
import { auth } from "../../firebase/firebaseConfig";
import { useNavigate } from "react-router-dom";
import {
	TextField,
	Button,
	Paper,
	Typography,
	Box,
	Divider
} from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";

const LoginForm = () => {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [isLoginClicked, setLoginClicked] = useState(false);
	const navigate = useNavigate();

	const handleLogin = async (e: React.FormEvent) => {
		e.preventDefault();
		try {
			setLoginClicked(true);
			await signInWithEmailAndPassword(auth, email, password);
			navigate("/");
		} catch (error) {
			const message =
				error instanceof Error ? error.message : "Login failed";
			alert(message);
		} finally {
			setLoginClicked(false);
		}
	};

	const handleGoogleSignIn = async () => {
		try {
			setLoginClicked(true);
			const provider = new GoogleAuthProvider();
			await signInWithPopup(auth, provider);
			navigate("/");
		} catch (error) {
			const message =
				error instanceof Error
					? error.message
					: "Google sign-in failed";
			alert(message);
		} finally {
			setLoginClicked(false);
		}
	};

	return (
		<Paper elevation={3} sx={{ p: 3 }}>
			<form onSubmit={handleLogin}>
				<Typography variant="h5" gutterBottom>
					Login
				</Typography>
				<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
					<TextField
						type="email"
						label="Email"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						required
					/>
					<TextField
						type="password"
						label="Password"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						required
					/>
					<Button
						type="submit"
						variant="contained"
						color="primary"
						disabled={isLoginClicked}
					>
						Login
					</Button>
				</Box>
			</form>

			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					gap: 1,
					mt: 3,
					mb: 1
				}}
			>
				<Divider sx={{ flex: 1 }} />
				<Typography variant="body2" color="text.secondary">
					Or
				</Typography>
				<Divider sx={{ flex: 1 }} />
			</Box>

			<Button
				variant="outlined"
				startIcon={<GoogleIcon />}
				onClick={handleGoogleSignIn}
				disabled={isLoginClicked}
				fullWidth
			>
				Sign in with Google
			</Button>
		</Paper>
	);
};

export default LoginForm;
